/* eslint-disable no-unused-vars */
import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import ConfirmPage from './Confirm'
import EventCreate from './Create'
import EventCreateItem from './CreateItem'
import DeliveryDetail from './DeliveryDetail'
// import EventDetail from './EventDetail'
import EventDetailV2Share from './EventDetailV2Share'
import EventDetailV2 from './EventDetailV2'
import HostedEvent from './HostedEvent'
import ListAllEventPlus from './ListAllEventPlus'
// import ListMyPurchases from './ListMyPurchases'
import ListMyPurchaseV2 from './ListMyPurchaseV2'
import ManageDelivery from './ManageDelivery'
import ManageOrder from './ManageOrder'
import PurchaseDetail from './PurchaseDetail'
import PackingList from './PackingList'
import './style.scss'
import ManagePackingList from './ManagePackingList'
import EventHosting from './EventHosting'

const Event = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${path}/hosting`} component={EventHosting} />
      <Route path={`${path}/created-confirm`} component={ConfirmPage} />
      <Route path={`${path}/create-items`} component={EventCreateItem} />
      <Route path={`${path}/create`} component={EventCreate} />
      <Route path={`${path}/update-confirm`} component={ConfirmPage} />
      <Route path={`${path}/update-items`} component={EventCreateItem} />
      <Route path={`${path}/update`} component={EventCreate} />
      <Route path={`${path}/list-my-events`} component={HostedEvent} />
      {/* <Route path={`${path}/list-my-purchases`} component={ListMyPurchases} /> */}
      <Route path={`${path}/list-my-purchases`} component={ListMyPurchaseV2} />
      <Route path={`${path}/detail`} component={EventDetailV2} />
      {/* <Route path={`${path}/detail-v2`} component={EventDetailV2} /> */}
      <Route path={`${path}/manage-orders`} component={ManageOrder} />
      <Route path={`${path}/purchase-detail`} component={PurchaseDetail} />
      <Route path={`${path}/detail-shared`} component={EventDetailV2Share} />
      <Route path={`${path}/delivery-detail`} component={DeliveryDetail} />
      <Route path={`${path}/manage-delivery`} component={ManageDelivery} />
      <Route path={`${path}/packing-list`} component={PackingList} />
      <Route path={`${path}/list-all-event-plus`} component={ListAllEventPlus} />
      <Route path={`${path}/list-packing-list`} component={ManagePackingList} />
    </Switch>
  )
}

export default Event
